import { z } from 'zod';

/////////////////////////////////////////
// INSPECTOR PERMISSION SCHEMA
/////////////////////////////////////////

export const InspectorPermissionSchema = z.object({
  id: z.bigint(),
  person_id: z.number().int(),
  city_id: z.number().int(),
  inspection_type_id: z.bigint(),
})

export type InspectorPermission = z.infer<typeof InspectorPermissionSchema>

export default InspectorPermissionSchema;
